import { HttpErrorResponse } from '@angular/common/http';

export function getErrorMessages(error: unknown | HttpErrorResponse): string[] {
  if (error instanceof HttpErrorResponse) {
    const apiErrorResponse = error.error;
    const apiValidationErrors = apiErrorResponse?.errors ? (Object.values(apiErrorResponse.errors) as string[]) : [];

    if (apiValidationErrors && apiValidationErrors.length > 0) {
      return apiValidationErrors;
    } else if (apiErrorResponse && apiErrorResponse.detail) {
      return [apiErrorResponse.detail];
    } else if (!apiErrorResponse && error.status === 403) {
      return ['You do not have permission to perform this action.'];
    }
  }

  return ['We were unable to process the request.'];
}
